import { useContext, useMemo } from 'react';
import FeatureFlagsContext, { FeatureFlagsContextType } from './Context';

const useFeatureFlag = (
  featureFlagKey: Parameters<FeatureFlagsContextType['checkFeatureFlag']>[0],
  data?: Parameters<FeatureFlagsContextType['checkFeatureFlag']>[1],
): boolean => {
  const { checkFeatureFlag } = useContext(FeatureFlagsContext);

  const value = useMemo(() => checkFeatureFlag(featureFlagKey, data), [
    checkFeatureFlag,
    data,
    featureFlagKey,
  ]);

  return value;
};

export default useFeatureFlag;
